import { booztLogo, booztletLogo, booztletLogoDe } from '@common/constants';

const deTaglineStores = ['de', 'at', 'ch'];
const hasDeTagline = store => deTaglineStores.includes(store);

export const getHeaderLogoName = (isBooztletEnv, store) => {
    if (isBooztletEnv && !hasDeTagline(store)) {
        return booztletLogo;
    }

    if (isBooztletEnv && hasDeTagline(store)) {
        return booztletLogoDe;
    }

    return booztLogo;
};
